<template>
  <div
    v-if="pages > 1"
    class="flex mx-auto space-x-4 justify-center mb-12"
  >
    <div v-if="page > 1" />
    <router-link
      v-if="page > 1"
      :to="{ query: pageQuery(page - 1) }"
      @click="changePageAndScrollToTop(page - 1)"
    >
      ←
    </router-link>
    <router-link
      v-for="eachPage in pages"
      :key="eachPage"
      :class="eachPage === page ? 'font-bold' : null"
      :to="{ query: pageQuery(eachPage) }"
      @click="changePageAndScrollToTop(eachPage)"
    >
      {{ eachPage }}
    </router-link>
    <router-link
      v-if="page < pages"
      :to="{ query: pageQuery(page + 1) }"
      @click="changePageAndScrollToTop(page + 1)"
    >
      →
    </router-link>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("collection");

export default {
  computed: mapState(["pages", "page"]),
  methods: {
    ...mapActions(["changePage"]),
    pageQuery: function (page) {
      let query = { ...this.$route.query, page: page }
      if (page == 1) { delete query.page }
      return query
    },
    async changePageAndScrollToTop(page) {
      await this.changePage(page)
      window.scrollTo(0,0)
    }
  },
};
</script>
